import type { BalloonSkin } from '../games/balloon/BalloonSkin.js';

export const GAME_ENTRIES = {
  balloons: 'src/games/balloon/BalloonGame.ts',
} as const;

export type GameId = keyof typeof GAME_ENTRIES;

export type GameSkins = {
  balloons: BalloonSkin;
};
